import React from 'react';
import Icon from '../AppIcon';

const ProfileCard = ({ profile, footerSlot, compact = false }) => {
  const joinDateLabel =
    profile?.joinDateLabel ||
    (profile?.createdAt?.toDate
      ? profile.createdAt.toDate().toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
      : 'Recently');

  const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(
    profile?.name || 'Learner'
  )}&background=6366f1&color=fff&bold=true`;

  const credentials = profile?.credentials || [];
  const coursesCompleted = typeof profile?.coursesCompleted === 'number' ? profile.coursesCompleted : null;
  const currentStreak = typeof profile?.currentStreak === 'number' ? profile.currentStreak : null;

  return (
    <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-lg">
      <div className="relative overflow-hidden p-8 text-center text-white" style={{ background: 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)' }}>
        <div className="absolute -top-10 -left-10 w-40 h-40 bg-white/10 rounded-full blur-2xl pointer-events-none" />
        <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-white/10 rounded-full blur-2xl pointer-events-none" />

        <div className="relative">
          <img
            src={avatarUrl}
            alt={profile?.name}
            className="w-20 h-20 rounded-full mx-auto mb-3 ring-4 ring-white/40 object-cover shadow-md"
          />
          <h2 className="text-2xl font-bold">{profile?.name}</h2>

          <div className="inline-flex items-center gap-1.5 mt-2 px-3 py-1 rounded-full bg-white/15 backdrop-blur-sm">
            <Icon name="BadgeCheck" size={13} className="text-white/80" />
            <span className="text-xs font-mono tracking-wide text-white/90">{profile?.nesolearnId}</span>
          </div>

          {profile?.location && (
            <p className="text-xs text-white/70 mt-2 flex items-center justify-center gap-1">
              <Icon name="MapPin" size={12} /> {profile.location}
            </p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-4 divide-x divide-border border-b border-border">
        <div className="p-3 text-center">
          <p className="text-lg font-bold text-foreground">{coursesCompleted ?? '—'}</p>
          <p className="text-[10px] text-muted-foreground mt-0.5 uppercase tracking-wide">Courses</p>
        </div>
        <div className="p-3 text-center">
          <p className="text-lg font-bold text-foreground">{credentials.length}</p>
          <p className="text-[10px] text-muted-foreground mt-0.5 uppercase tracking-wide">Credentials</p>
        </div>
        <div className="p-3 text-center">
          <p className="text-lg font-bold text-foreground">{currentStreak ?? '—'}</p>
          <p className="text-[10px] text-muted-foreground mt-0.5 uppercase tracking-wide">Day streak</p>
        </div>
        <div className="p-3 text-center">
          <p className="text-sm font-bold text-foreground leading-tight">{joinDateLabel}</p>
          <p className="text-[10px] text-muted-foreground mt-0.5 uppercase tracking-wide">Since</p>
        </div>
      </div>

      {!compact && credentials.length > 0 && (
        <div className="p-5 border-b border-border">
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-3">
            Skills Passport
          </p>
          <div className="flex flex-wrap gap-2">
            {credentials.map((cred) => (
              <div
                key={cred?.certId}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent/10 border border-accent/20"
              >
                <Icon name="Award" size={12} className="text-accent" />
                <span className="text-xs font-medium text-foreground">{cred?.courseTitle}</span>
                {cred?.orgVerified && <Icon name="BadgeCheck" size={12} className="text-accent" />}
              </div>
            ))}
          </div>
        </div>
      )}

      {!compact && (
        <div className="p-5 border-b border-border">
          <p className="text-xs font-semibold text-muted-foreground uppercase tracking-wide mb-3">
            Coming to your Identity
          </p>
          <div className="flex flex-wrap gap-2">
            {['Learning Paths', 'Projects', 'Proof of Learning'].map((label) => (
              <div
                key={label}
                className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-muted/60 border border-dashed border-border"
              >
                <Icon name="Clock" size={12} className="text-muted-foreground" />
                <span className="text-xs font-medium text-muted-foreground">{label}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {footerSlot && <div className="p-5">{footerSlot}</div>}
    </div>
  );
};

export default ProfileCard;